const INSTRUCTIONS_PLACEHOLDER_TEXT =
  'Ex: Prédio azul com varanda ao lado do posto de saúde.';

const FINISH_BUTTON_TEXT = 'Finalizar';

const FINISH_BUTTON_DATA_TEST_ID = 'finish-btn';

export {
  INSTRUCTIONS_PLACEHOLDER_TEXT,
  FINISH_BUTTON_TEXT,
  FINISH_BUTTON_DATA_TEST_ID
};
